import React, { FC, memo } from 'react';

import { SearchInputProps } from './models';
import SearchBoxComponent from './SearchBoxComponent';

import './SearchInput.scss';

const SearchInput: FC<SearchInputProps> = ({
  searchPlaceholder,
  searchButtonText,
  fetchSearchResults,
}) => (
  <div className="search-input__container">
    <form role="search" className="search-input__form">
      <SearchBoxComponent
        searchPlaceholder={searchPlaceholder}
        searchButtonText={searchButtonText}
        fetchSearchResults={fetchSearchResults}
      />
    </form>
  </div>
);

export default memo(SearchInput);
